export const VALIDATE = "@AUTH.VALIDATE";
export const CREATE_SESSION = "@AUTH.CREATE_SESSION";
export const REGISTER = "@AUTH.REGISTER";
export const LOGOUT = "@AUTH.LOGOUT";
export const CLEAR_ERROR = "@AUTH.CLEAR_ERROR";
export const VERIFY_ACCOUNT = "@AUTH.VERIFY_ACCOUNT";
export const GET_VERIFY_ACCOUNT_LINK = "@AUTH.GET_VERIFY_ACCOUNT_LINK";
export const RESET_PASSWORD = "@AUTH.RESET_PASSWORD";
export const GET_RESET_PASSWORD_LINK = "@AUTH.GET_RESET_PASSWORD_LINK";
export const CHANGE_ACCOUNT_PASSWORD = "@AUTH.CHANGE_ACCOUNT_PASSWORD";
export const CHANGE_ACCOUNT_EMAIL = "@AUTH.CHANGE_ACCOUNT_EMAIL";
